import type { TowerDesign } from "@/game/towerSpec";
import type { Section } from "@/physics/model";
/**
 * Madison 180 ft ROHN Model 80 guyed lattice tower (New Rd, Madison CT), from
 * reference_towers/02_engineering_drawings/CT_Madison_NewRd_ROHN_180ft_guyed_lattice_structural.pdf.
 * EXACT: 180 ft (54.86 m), three-legged ROHN Model 80 guyed lattice, face width
 * 3.41 ft top & bottom (constant) → circumradius 0.600 m, bolted connections.
 * TIA-222-?, 105 mph, 1.00" ice. Guys at ~150 & 184 ft radii (report) → standard
 * 4-level attach spacing (flagged).
 */

// Ø16 solid-round bracing. Real area (2.01e-4 m² — drives weight/wind/tension) but
// EFFECTIVE moment of inertia: the ROHN 80 lattice braces the leg finely (~0.5 m
// pitch), so the brace's true buckling unbraced length is far shorter than the ~2 m
// panel diagonal our pin-jointed X-brace builds. Modelling it as an isolated Ø16
// strut gives a nonsense ~1.6 kN buckling capacity that gravity + guy pretension
// exceed instantly. Scaling I by (panel/pitch)² ≈ (2.0/0.5)² restores the real
// continuously-braced capacity. Same modelling fix as the ROHN 45G. (I_geom = 3.2e-9)
const BRACE_80: Section = { name: "ROHN 80 brace (Ø16 round)", A: 2.01e-4, I: 4.7e-8, dragWidth: 0.016 };

export const design: TowerDesign = {
  id: "guyed-madison-180ft",
  name: "Guyed Lattice (Madison 180 ft, ROHN 80)",
  description: "Real 180 ft ROHN Model 80 guyed lattice, Madison CT (105 mph, 1in ice).",
  author: "reference: CT Madison New Rd ROHN 180 ft SA",
  spec: {
    type: "guyed",
    height: 54.86,
    stack: { faces: 3, panels: 36, baseRadius: 0.6, topRadius: 0.6,
      legSection: "legHeavy", braceSection: BRACE_80, legMaterial: "a572", braceMaterial: "a572", bracing: "X" },
    guys: [0.28, 0.5, 0.72, 0.94].map((f, i) => ({ atHeightFrac: f, anchorRadius: 24 + i * 8, section: "guy38", material: "guyStrand", pretensionStrain: 0.001 })),
    foundation: { soil: "stiff-clay", base: { type: "pier", width: 0.6, diameter: 0.6, depth: 1.5, concrete: "c20" }, anchor: { type: "deadman", width: 1.5, diameter: 0.6, depth: 2, concrete: "c20" } },
  },
};
